export const EVENTS_SCHEMA_VERSION = "0.53.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.26.0";
